import "./Form.scss";
import Button from "../Button/Button";
import {
  generateTimeLabels,
  displayCurrentHour,
  formatDateTimeToUnix,
  formatUnixToDatetime,
  convertRecommendationDate,
  getURLParams,
} from "../../utils/helper";
import Dropdown from "../Dropdown/Dropdown";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../api/api";
import Spin from "../Spin/Spin";

const Form = ({
  formSubmitHandler,
  setOpenEditModal,
  editHandler,
  item,
  formErrors,
  setFormErrors,
}) => {
  const [selectedItem, setSelectedItem] = useState({
    datetime: "",
    subreddit: "",
    title: "",
    content: "",
  });
  const [hour, setHour] = useState(
    item ? formatUnixToDatetime(item.datetime)[1] : displayCurrentHour
  );
  const [loading, setLoading] = useState({ content: false, title: false });
  const location = useLocation();

  const getDraft = (_e, content) => {
    if (!content) {
      return;
    }
    setFormErrors({ ...formErrors, content: false });
    setLoading({ ...loading, content: true });
    axios
      .post(`${BASE_URL}/ai/write-draft`, {
        description: content,
        numTokens: 512,
      })
      .then((res) => {
        if (res.data.modelResponse[0].generated_text) {
          setSelectedItem({
            ...selectedItem,
            content: res.data.modelResponse[0].generated_text,
          });
        } else throw new Error("Error with inference service");
        setLoading({ ...loading, content: false });
      })
      .catch((error) => {
        console.log("getDraft() error", error);
        setLoading({ ...loading, content: false });
        setFormErrors({
          ...formErrors,
          content:
            "Inference service currently unavailable - please try again later",
        });
      });
  };

  const rephraseTitle = async (_e, title) => {
    try {
      if (!title) {
        return;
      }

      setFormErrors({ ...formErrors, title: "" });
      setLoading({ ...loading, title: true });

      const res = await axios.post(`${BASE_URL}/ai/rephrase`, {
        description: title,
      });

      if (res.data.modelResponse) {
        setSelectedItem({
          ...selectedItem,
          title: res.data.modelResponse,
        });
      } else {
        throw new Error("Error with inference service");
      }
    } catch (error) {
      console.log("rephraseTitle() error", error);
      setFormErrors({
        ...formErrors,
        title:
          "Inference service currently unavailable - please try again later",
      });
    }
    setLoading({ ...loading, title: false });
  };

  // on mount
  useEffect(() => {
    const checkSessionStorage = () => {
      const recommendation = sessionStorage.getItem("rec");

      if (recommendation) {
        const rec = JSON.parse(recommendation);
        // bandaid solution. Adds query params to URL but values are read via return
        window.history.pushState(
          "",
          "",
          `/schedule?time=${rec.time}&day=${rec.dayOfWeek}&sr=${rec.searchTerm}`
        );

        sessionStorage.removeItem("rec");
        return { time: rec.time, day: rec.dayOfWeek, sr: rec.searchTerm };
      }
      return {};
    };

    const urlParams = checkSessionStorage(location);

    // if logged in prior to clicking recommendation card do:
    if (location.search.includes("time")) {
      const params = getURLParams(location.search);

      setHour(displayCurrentHour(false, Number(params.time)));
      // console.log(
      //   "date in includes(time)",
      //   formatDateTimeToUnix(convertRecommendationDate(params.day), hour)
      // );
      setSelectedItem({
        ...selectedItem,
        datetime: formatDateTimeToUnix(
          convertRecommendationDate(params.day),
          hour
        ),
        subreddit: params.sr,
      });
    }
    // Bandaid solution: user clicks on recommendation card -> logs in -> lands on schedule page
    else if (Object.keys(urlParams).length > 0) {
      setHour(displayCurrentHour(false, urlParams.time));
      setSelectedItem({
        ...selectedItem,
        datetime: formatDateTimeToUnix(
          convertRecommendationDate(urlParams.day),
          hour
        ),
        subreddit: urlParams.sr,
      });
    } else if (item) {
      setSelectedItem({
        ...item,
        datetime: formatDateTimeToUnix(
          formatUnixToDatetime(new Date(item.datetime))[0],
          hour
        ),
      });
    }
  }, [location, item, hour]); // selectedItem

  return (
    <form
      className="form"
      onSubmit={
        item
          ? (e) => {
              editHandler(e, item.id, selectedItem, setOpenEditModal);
            }
          : (e) => {
              formSubmitHandler(e, hour, setSelectedItem);
            }
      }
    >
      {item ? (
        <div className="form__test">
          <h1 className="form__title">Edit Your Scheduled Post</h1>
        </div>
      ) : formErrors.limit ? (
        <div className="form__test">
          <h1 className="form__title">Schedule a New Post </h1>
          <span className="form__limit"> - Limit reached*</span>
        </div>
      ) : (
        <div className="form__test">
          <h1 className="form__title">Schedule a New Post </h1>
        </div>
      )}
      <section className="form__container">
        <div className="form__date-container">
          <div className="form__input-container">
            <div className="form__input-subcontainer">
              {" "}
              <label htmlFor="date" className="form__label">
                Date
              </label>
              {formErrors.datetime && (
                <p className="form__error">
                  - A valid field entry is required*
                </p>
              )}
            </div>
            <input
              type="date"
              name="date"
              className="form__input"
              min={formatUnixToDatetime(Date.now())[0]}
              value={
                selectedItem.datetime.length === 0
                  ? formatUnixToDatetime(Date.now())[0]
                  : formatUnixToDatetime(selectedItem.datetime)[0]
              }
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  datetime: formatDateTimeToUnix(e.target.value, hour),
                })
              }
            />
          </div>
          <div className="form__dropdown-wrapper">
            <Dropdown
              genericState={hour}
              setGenericState={setHour}
              labels={generateTimeLabels(" ")}
              className={"drop"}
            />
          </div>
        </div>
        <div className="form__input-container">
          <div className="form__input-subcontainer">
            <label htmlFor="subreddit" className="form__label">
              Subreddit
            </label>
            {formErrors.subreddit && (
              <p className="form__error">A valid field entry is required*</p>
            )}
          </div>
          <input
            type="text"
            name="subreddit"
            id="subreddit"
            className="form__input"
            value={selectedItem.subreddit}
            onChange={(e) =>
              setSelectedItem({ ...selectedItem, subreddit: e.target.value })
            }
          />
        </div>
        <div className="form__input-container">
          <div className="form__input-subcontainer">
            <label htmlFor="title" className="form__label">
              Title
            </label>
            <div className="form__input-wrapper">
              {loading.title && <Spin modifier={"waiting"} />}
            </div>
            {formErrors.title && (
              <p className="form__error">{formErrors.title}</p>
            )}
          </div>
          <input
            type="text"
            name="title"
            className="form__input"
            value={selectedItem.title}
            onChange={(e) =>
              setSelectedItem({ ...selectedItem, title: e.target.value })
            }
          />
        </div>
        <div className="form__input-container">
          <div className="form__input-subcontainer">
            <label htmlFor="Content" className="form__label">
              Content
            </label>{" "}
            <div className="form__input-wrapper">
              {loading.content && <Spin modifier={"waiting"} />}
            </div>
            {formErrors.content && (
              <p className="form__error">{formErrors.content}</p>
            )}
          </div>
          <textarea
            type="text"
            name="content"
            className="form__textarea"
            value={selectedItem.content}
            onChange={(e) =>
              setSelectedItem({ ...selectedItem, content: e.target.value })
            }
          />
        </div>
      </section>
      <div
        className={`form__button-container ${
          item ? "form__button-container--align-left" : ""
        }`}
      >
        {item ? (
          <>
            <Button
              label="Close"
              type={"cancel"}
              action={() => setOpenEditModal(false)}
            />
            <Button label="Save Edit" type={"send"} />
          </>
        ) : (
          <>
            <Button label="Add to Queue" type={"send"} />
            <div className="form__button-subcontainer">
              <h3 className="form__button-title">New AI Features:</h3>
              <div className="form__button-wrapper">
                <Button
                  type="rewrite"
                  label="Continue Draft"
                  action={(e) => getDraft(e, selectedItem.content)}
                />
                <Button
                  type="rewrite"
                  label="Rephrase Title"
                  action={(e) => rephraseTitle(e, selectedItem.title)}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </form>
  );
};

export default Form;
